import styled from 'styled-components';
import { Button } from '../CommonComponents/OPL/Button/Button';

export const PageDescription = styled.p`
  font-size: 16px;
  color: #444444;
  font-weight: 400;
  line-height: 30px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
`;

export const StyledButton = styled(Button)<{ isEmbeddedMobile: boolean }>(
  ({ isEmbeddedMobile }) => ({
    display: 'flex',
    marginLeft: 'auto',
    marginTop: isEmbeddedMobile ? 8 : 0,
    marginRight: isEmbeddedMobile ? 8 : 0,
  }),
);
